import React, { useState } from "react";
import { Field, reduxForm } from 'redux-form';
import renderSelectField from '../../../../shared/components/form/Select';
import renderDateField from '../../../../shared/components/form/DatePicker';
import Box from '@mui/material/Box';
import { Button } from 'reactstrap';
import ProgressBar  from '../../../../shared/components/ProgressBar';

const Invoice = ({title, handleSubmit, loading, pristine, submitting, reset}) => {
  const [employeeNumber, setEno] = useState('');
  const [employeeFirstName, setFname] = useState('');
  const [employeeLastName, setLname] = useState('');
  const [irdNumber, setEird] = useState('');
  const [claimNumber, setCno] = useState('');
  const [employerId, setEmployerId] = useState('');
  const [paymentFromDate, setPaymentStartDate] = useState();
  const [paymentToDate, setPaymentEndDate] = useState();
  const [eligibilityFromDate, setAccStartDate] = useState();
  const [eligibilityToDate, setAccEndDate] = useState();
  const [eraStatus, setEraStatus] = useState(null);

  const handleChange = (e,setIdentifierState) => {
    const { name, value} = e.target;
    setIdentifierState(value)
  };


  return (
    <>
      <Box component="form" sx={{  width: 500 ,'& > :not(style)': { m: 1 },}} noValidate autoComplete="off">
        <form className="form form--horizontal wizard__form">
          <h3 className="wizard__title">{ title }</h3>
          <div className="form__form-group">
              <span className="form__form-group-label">Employee Number</span>
              <div className="form__form-group-field">
                <div className="container">
                  <Field
                      name="employeeNumber"
                      id="employeeNumber"
                      placeholder="Employee Number"
                      type="text"
                      component="input"
                      value={employeeNumber}
                      onChange={(e)=>handleChange(e,setEno)}
                  />
                </div>
              </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Employee</span>
            <div className="form__form-group-field">
              <div className="container">
                  <Field
                  name="employeeFirstName"
                  id="employeeFirstName"
                  placeholder="First Name"
                  type="text"  
                  component="input"
                  value={employeeFirstName}
                  onChange={(e)=>handleChange(e,setFname)}
                  />
              </div>
              <div className="container">
                  <Field
                  type="text"
                  name="employeeLastName"
                  id="employeeLastName"
                  placeholder="Last Name"
                  component="input"
                  value={employeeLastName}
                  onChange={(e)=>handleChange(e,setLname)}
                  />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Employee IRD</span>
            <div className="form__form-group-field">
              <div className="container">
                <Field
                    name="irdNumber"
                    id="irdNumber"
                    placeholder="Employee IRD"
                    type="text"
                    component="input"
                    value={irdNumber}
                    onChange={(e)=>handleChange(e,setEird)}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Claim Number</span>
            <div className="form__form-group-field">
              <div className="container">
                <Field
                    name="claimNumber"
                    id="claimNumber"
                    placeholder="Claim Number"
                    type="text"
                    component="input"
                    value={claimNumber}
                    onChange={(e)=>handleChange(e,setCno)}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Employer ID</span>
            <div className="form__form-group-field">
              <div className="container">
                <Field
                    name="employerId"
                    id="employerId"
                    placeholder="Employer ID"
                    type="text"
                    component="input"
                    value={employerId}
                    onChange={(e)=>handleChange(e,setEmployerId)}
                />
              </div>
            </div>
          </div>
         <div className="form__form-group">
            <span className="form__form-group-label">Payment Date</span>
            <div className="form__form-group-field">
              <div className="container">
                <Field
                id="paymentFromDate"
                name="paymentFromDate"
                placeholder="Start Date"
                component={renderDateField}
                onChange={(val)=>setPaymentStartDate(val)}
              />
              </div>
              To
              <div className="container">
              <Field
                id="paymentToDate"
                name="paymentToDate"
                placeholder="End Date"
                component={renderDateField}
                onChange={(val)=>setPaymentEndDate(val)}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Eligiblity End Date</span>
            <div className="form__form-group-field">
              <div className="container">
                  <Field
                  name="eligibilityFromDate"
                  id="eligibilityFromDate"
                  placeholder="Start Date"
                  component={renderDateField}
                  onChange={(val)=>setAccStartDate(val)}
                  />
              </div>
              To
              <div className="container">
                  <Field
                  type="text"
                  name="eligibilityToDate"
                  id="eligibilityToDate"
                  placeholder="End Date"
                  component={renderDateField}
                  onChange={(val)=>setAccEndDate(val)}
                  />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">ERA Status</span>
            <div className="form__form-group-field">
              <div className="container">
                <Field
                  name="eraStatus"
                  component={renderSelectField}
                  type="text"
                  options={[
                    { value: "X" , label: 'True' },
                    { value: " " , label: 'False' },
                  ]}
                  placeholder="ERA Status"
                  onChange={(e)=>setEraStatus(e.value)}
                />
              </div>
            </div>
         </div>        
        </form>
      </Box>
      <Box sx={{'& > :not(style)': { m: 1 },}} noValidate autoComplete="off">  
        <Button type="submit"disabled={pristine || submitting}  color="primary" onClick={handleSubmit}> {loading?<ProgressBar size={"8"} />:'Download'} </Button>
        <Button disabled={pristine || submitting}  color="primary" onClick={reset}> {'Reset'} </Button>
      </Box>
    </>
  );
};

export default reduxForm({
    form: 'invoice_form', // a unique identifier for this form
  })(Invoice);